export enum NotificationType {
  REVIEW_REQUESTED = "review_requested",
  PR_SUBMITTED = "pr_submitted",
  COMMENT_RESOLVED = "comment_resolved",
  PR_UPDATED = "pr_updated",
  COMMENT = "comment"
}

export interface NormalizedReviewRequested {
  linkHref: string
  title: string
  author: string
  authorAvatar?: string
}

export interface NormalizedPrUpdated {
  linkHref: string
  title: string
  updater: string
  updaterAvatar?: string
}

export interface NormalizedCommentResolved {
  linkHref: string
  title: string
  resolvedBy: string
  resolvedByAvatar?: string
}

export interface NormalizedPrSubmitted {
  linkHref: string
  title: string
  reviewer: string
  reviewerAvatar?: string
}

export interface NormalizedComment {
  linkHref: string
  title: string
  reviewer: string
  reviewerAvatar?: string
  body?: string
}

export type NormalizedPayload =
  | NormalizedComment
  | NormalizedReviewRequested
  | NormalizedPrSubmitted
  | NormalizedCommentResolved
  | NormalizedPrUpdated

export interface Notification {
  id: number
  userId: string
  type: NotificationType
  payload: NormalizedPayload
  read: boolean
  createdAt: string
}

export interface AvatarField {
  avatar?: string
  name: string
}

export interface NotificationWithAvatar extends Notification {
  avatarField: AvatarField
}
